/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Logs_Found_TitleInputs */

const en_no_logs_found_title = /** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silence is Golden`)
};

const es_no_logs_found_title = /** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El silencio es oro`)
};

const fr_no_logs_found_title = /** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le silence est d'or`)
};

const de_no_logs_found_title = /** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schweigen ist Gold`)
};

const id_no_logs_found_title = /** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesunyian adalah Emas`)
};

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const ja_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const zh_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const ar_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const it_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const ru_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const pt_no_logs_found_title = en_no_logs_found_title;

/** @type {(inputs: No_Logs_Found_TitleInputs) => LocalizedString} */
const ko_no_logs_found_title = en_no_logs_found_title;

/**
* | output |
* | --- |
* | "Silence is Golden" |
*
* @param {No_Logs_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_logs_found_title = /** @type {((inputs?: No_Logs_Found_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Logs_Found_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_logs_found_title(inputs)
	if (locale === "es") return es_no_logs_found_title(inputs)
	if (locale === "fr") return fr_no_logs_found_title(inputs)
	if (locale === "de") return de_no_logs_found_title(inputs)
	if (locale === "ja") return ja_no_logs_found_title(inputs)
	if (locale === "zh") return zh_no_logs_found_title(inputs)
	if (locale === "ar") return ar_no_logs_found_title(inputs)
	if (locale === "id") return id_no_logs_found_title(inputs)
	if (locale === "it") return it_no_logs_found_title(inputs)
	if (locale === "ru") return ru_no_logs_found_title(inputs)
	if (locale === "pt") return pt_no_logs_found_title(inputs)
	return ko_no_logs_found_title(inputs)
});